import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CTAWrapper from '../CTAWrapper'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import Avatar from 'srcReact/components/common2/Avatar'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import Modal from 'srcReact/components/common2/Modal'
import CTANewMembersFull from '../CTANewMembersFull'
import WorkplaceTile from 'srcReact/components/common2/WokplaceTile'
import { isMobileScreen } from 'srcReact/helpers/utils'

function CTANewMembers(props) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const {
    common: { isNative },
    feedHome: { ctas }
  } = useSelector((state) => state)

  const showUserModal = (userId) => {
    const lp = new LightProfileProto()
    lp.userId = userId
    dispatch(lightProfileActions.openLightProfileModal(lp))
  }

  const showModal = () => {
    setIsModalOpen(true)
  }
  const closeModal = () => {
    setIsModalOpen(false)
  }

  return ctas?.new_members?.total_new_member_count > 0 ? (
    <CTAWrapper title={t('feedCTAs.newMembers', { count: ctas.new_members.total_new_member_count })}>
      <div className={styles.newMemberWrapper}>
        {ctas.new_members.workplaces ? (
          <div className={styles.workplaces}>
            {Object.keys(ctas.new_members.workplaces).map((wpKey) => (
              <WorkplaceTile
                workplaceId={ctas.new_members.workplaces[wpKey].id}
                workplaceName={ctas.new_members.workplaces[wpKey].name}
                color={ctas.new_members.workplaces[wpKey].color}
                initials={ctas.new_members.workplaces[wpKey].initials}
                size='tiny'
                tileClassName={styles.tile}
                isNative={isNative}
              />
            ))}
          </div>
        ) : null}

        <div className={styles.members}>
          {ctas?.new_members?.members_with_common_interest_top_3.map((member) => {
            return (
              <Avatar
                imgWrapperSize='medium64'
                containerCSS={styles.avatar}
                userId={member.user_id}
                profilePicture={member.profile_picture}
                firstname={member.firstname}
                lastname={member.lastname}
                mimeType={member.mime_type}
                originalTag={member.original_tag}
                isOriginal={member.is_original}
                showUserName={true}
                userNameCSS={styles.userName}
                showCommonInterests={true}
                commonInterestsCount={Object.keys(member.common_interests).length}
                withExpertiseGroup={member.with_expertise_group}
                onClickAction={() => {
                  showUserModal(member.user_id)
                }}
              />
            )
          })}
        </div>
        {ctas.new_members.total_new_member_count > 3 && (
          <div className={styles.footer}>
            <div
              className={`${styles.avatarsOverlapped} ${
                styles[`avatarsOverlapped${ctas.new_members.some_profile_pictures.length}`]
              }`}>
              {ctas.new_members.some_profile_pictures.map((picture, index) => {
                return (
                  <Avatar
                    key={index}
                    profilePicture={picture.profil_picture}
                    imgWrapperSize={'xsmall'}
                    containerCSS={`${styles[`avatar${index}`]}`}
                    mimeType={picture.mime_type}
                    originalTag={picture.original_tag}
                    isOriginal={picture.is_original}
                    focusable={false}
                    withExpertiseGroup={picture.with_expertise_group}
                  />
                )
              })}
            </div>
            <div className={styles.text}>
              <span
                className={styles.totalMembers}
                dangerouslySetInnerHTML={{
                  __html: t('feedCTAs.newMemberDesc', {
                    count: ctas.new_members.total_new_member_count,
                    workplaceName: ctas.new_members.members_with_common_interest_top_3[0].workplace_name
                  })
                }}
              />
              <span>, </span>
              <button type='button' onClick={showModal} className={styles.btnSeeAll}>
                {t('feedCTAs.seeFullList')}
              </button>
            </div>
          </div>
        )}
      </div>
      {isModalOpen && (
        <Modal isOpen={isModalOpen} handleClose={closeModal} title={t('feedCTAs.newMembers_plural')}>
          <CTANewMembersFull />
        </Modal>
      )}
    </CTAWrapper>
  ) : null
}

export default CTANewMembers
